import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { link, reverseLinkUnderline } from '@helpers/typography';
import RegionSelectorStyles from '@stories/Components/Misc/RegionSelector/RegionSelector.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  &[data-variant='blue'] {
    background-color: ${brand.primary.blue.dark};
    color: ${brand.global.white};
  }

  &[data-variant='yellow'] {
    background-color: ${brand.secondary.yellow.light};
    color: ${brand.primary.purple.dark};
  }

  ${SectionWrapperStyles.Inner} {
    --textLinkColour: currentColor;

    display: grid;
    gap: 24px;
    height: var(--announcementHeight);

    @media ${from(Device.DesktopSmall)} {
      grid-template-columns: 1fr auto 1fr;
    }
  }

  @media ${until(Device.DesktopSmall)} {
    ${() => CtaWrapper} {
      display: none;
    }
  }
`;
const Announcement = styled.p `
  ${fonts.lato.regular};

  font-size: ${fluid(12, 16)};
  line-height: ${fluid(16, 24)};
  margin: auto;

  a {
    ${link};
    ${reverseLinkUnderline};

    font-weight: 700;
  }

  @media ${from(Device.DesktopSmall)} {
    grid-column: 2;
  }
`;
const CtaWrapper = styled.div `
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-end;
  grid-column: 3;

  ${RegionSelectorStyles.Container} {
    color: currentColor;
  }

  > a {
    ${fonts.lato.semiBold};
    ${link};

    font-size: 16px;
    line-height: 24px;
  }

  @media ${from(Device.DesktopSmall)} {
    ${RegionSelectorStyles.Regions} {
      left: auto;
      right: 0;
    }
  }
`;
const AnnouncementBarStyles = {
    Container,
    CtaWrapper,
    Announcement,
};
export default AnnouncementBarStyles;
